import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, WizardServiceLocator, DialogService } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';
import { LogContainer } from '@sdbn/tmc-common';
import { TerminalContextConstants } from '@sdbn/tmc-common';
import { PageCall } from '@sdbn/tmc-common';
import { VisitorLeaveResult } from '../widgets/terminal/visitor-leave.model';
import { ResponseStatus } from '@sdbn/common';
import { TerminalVisitorRegistration } from '../widgets/terminal/visitor-registration.model';

export class VisitorLeaveSendDataToBackendController extends AbstractStepController {

    errorOccured = false;

    appServerAPI: AppServerAPI;

    constructor() {
        super();
        this.appServerAPI = WizardServiceLocator.injector.get(AppServerAPI);
    }

    onContextChange(contextChange: ContextChange) {
    }

    onRegisterToDashboardContext() {
    }

    public handleFlow(): FlowStepHandleResult {
        const result = new FlowStepHandleResult();
        result.type = HandleResultType.PROCESSING;

        const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
        logContainer.addLog('send data to backend started');

        this.confirmLeave();

        return result;
    }

    getControls(): StepControl[] {
        const controls = new Array<StepControl>();
        return controls;
    }


    private confirmLeave(): Promise<void> {
        this.dashboardContext.setContextValue(TerminalContextConstants.registrationFinished, new Date().getTime());
        return this.executeConfirmLeave().toPromise()
            .then(response => {
                console.log('confirm Leave call succeeded:', response);
                // Finally call next Wizard Step
                if (this.errorOccured || response.status === ResponseStatus.FAILED) {
                  this.wizardComponent.next('visitor-leave-failed');
                } else {
                  this.wizardComponent.next();
                }
            }, error => {
              console.log('saveMasterData call failed:', error);
              this.showHttpError();
          });
    }


    private executeConfirmLeave() {

        const dto = new TerminalVisitorRegistration();
        // Terminal identifier setzen
        dto.terminalIdentifier = this.dashboardContext.getContextValue('terminalIdentifier');
        dto.name = this.dashboardContext.getContextValue(TerminalContextConstants.lastname);
        dto.firstname = this.dashboardContext.getContextValue(TerminalContextConstants.firstname);
        dto.company = this.dashboardContext.getContextValue(TerminalContextConstants.company);
        dto.numberPlate = this.dashboardContext.getContextValue(TerminalContextConstants.numberPlate);
        dto.reason = this.dashboardContext.getContextValue(TerminalContextConstants.reasonForVisit);
        dto.gcCaseId = this.dashboardContext.getContextValue(TerminalContextConstants.gcCaseId);
        dto.gcCaseUrl = this.dashboardContext.getContextValue(TerminalContextConstants.gcCaseUrl);
        dto.messagingLanguage = this.dashboardContext.getContextValue(TerminalContextConstants.language);

        const logContainer: LogContainer = this.dashboardContext.getContextValue(TerminalContextConstants.logContainer);

        for (const logEntry of logContainer.logEntries) {
            dto.pageCalls.push(new PageCall({ key: logEntry.message, timestamp: logEntry.timestamp }));
        }

        dto.registrationId = this.dashboardContext.getContextValue(TerminalContextConstants.registrationId);
        dto.registrationFinished = this.dashboardContext.getContextValue(TerminalContextConstants.registrationFinished);
        dto.registrationStarted = this.dashboardContext.getContextValue(TerminalContextConstants.registrationStarted);
        dto.smartphoneConnected = this.dashboardContext.getContextValue(TerminalContextConstants.smartphoneConnected);
        dto.smartphoneRequired = this.dashboardContext.getContextValue(TerminalContextConstants.driverCommunication)
            === TerminalContextConstants.DRIVER_COMMUNICATION_LOANER;

        console.log('execute visitor leave backend call', dto);

        return this.appServerAPI.execute<VisitorLeaveResult>(`/terminal/registration/visitor/leave`, dto);
    }

    private showHttpError() {
        this.errorOccured = true;

        const matDialog = WizardServiceLocator.injector.get(DialogService);
        matDialog.showInfoDialog(
          'tmc-yard.widgets.registration-terminal.http.error.title',
          'tmc-yard.widgets.registration-terminal.http.error.message',
        ).afterClosed().subscribe(
            () => this.wizardComponent.startProcessFlow('registration-terminal-wizard-configuration')
        );
    }
}
